// @ts-check
/**
 * @typedef {import('./strategies/AdyenStrategy').AdyenStrategy} AdyenStrategy
 * @typedef {import('./strategies/CybersourceStrategy').CybersourceStrategy} CybersourceStrategy
 * @typedef {import('./strategies/KushkiStrategy').KushkiStrategy} KushkiStrategy
 */

/**
 * Card Payment Method
 * @function Card
 */
const Card = () => {
  /**
   * @type {AdyenStrategy | CybersourceStrategy | KushkiStrategy | undefined}
   */
  let strategy;

  /**
   * Set the strategy
   * @param {AdyenStrategy | CybersourceStrategy | KushkiStrategy} newStrategy
   * @returns {void}
   */
  const setStrategy = (newStrategy) => {
    strategy = newStrategy;
  };

  /**
   * Create a token for the card
   * @param {*} data - The data
   * @param {*} cardInfo - The card information
   * @returns {Promise<string>} The token
   */
  const createPayload = (data, cardInfo) => {
    if (!strategy) {
      throw new Error('Card strategy not set');
    }

    return strategy.createPayload(data, cardInfo);
  };

  return {
    setStrategy,
    createPayload,
  };
};

const card = Card();

export default card;
